import React from "react";
import shortid from "shortid";
import { Drawer, Row, Col, Form, Input, Select, Button } from "antd";
import InputMask from "react-input-mask";
import CurrencyFormat from "react-currency-format";

const Option = Select.Option;

const pisOptions = [
  { id: shortid.generate(), value: "Tributado", text: "Tributado" },
  {
    id: shortid.generate(),
    value: "Tributação Monofásica",
    text: "Tributação Monofásica",
  },
  {
    id: shortid.generate(),
    value: "Substituição Tributária",
    text: "Substituição Tributária",
  },
];

const icmsOptions = [
  { id: shortid.generate(), value: "Tributado", text: "Tributado" },
  {
    id: shortid.generate(),
    value: "Substituição Tributária",
    text: "Substituição Tributária",
  },
  {
    id: shortid.generate(),
    value: "Antecipação com Encerramento",
    text: "Antecipação com Encerramento",
  },
];

const DrawerFilter = (props) => {
  const {
    sCfop,
    sChave,
    sCodigoProduto,
    sCst,
    sDataEmissao,
    sDescricao,
    sEan,
    sEx,
    sIndicadorOperacao,
    sModelo,
    sNcm,
    sNumeroNota,
    sQuantidade,
    sSituacao,
    sTotalBruto,
  } = props.filter;

  async function cleanFilters() {
    await props.handleReset();
    props.handleFilters();
  }

  return (
    <Drawer
      title="Filtrar produtos"
      className="ant-drawer--custom"
      width={600}
      onClose={props.onClose}
      visible={props.visibleDrawer}
    >
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Descrição">
              <Input
                className="form-control"
                name="Descricao"
                value={sDescricao && sDescricao.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                maxLength="100"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Código do Item">
              <Input
                className="form-control"
                name="CodigoProduto"
                value={sCodigoProduto && sCodigoProduto.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                maxLength="100"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="NCM">
              <InputMask
                className="form-control"
                name="Ncm"
                value={sNcm ? sNcm.substr(1) : ""}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                mask={"9999.99.99"}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="EX">
              <Input
                className="form-control"
                name="Ex"
                value={sEx && sEx.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                type="number"
                min="0"
                maxLength="3"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="EAN">
              <Input
                className="form-control"
                name="Ean"
                value={sEan && sEan.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                type="number"
                min="0"
                maxLength="14"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tributação PIS/COFINS">
              <Select
                className="ant-select--custom"
                defaultValue={props.selectedPis}
                value={props.selectedPis}
                onChange={(e) =>
                  props.handleChangeField(e, "DescricaoTributacaoPisCofins")
                }
              >
                <Option value={null}>Todos</Option>
                {pisOptions.map((item) => {
                  return (
                    <Option key={item.id} value={item.value}>
                      {item.text}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Tributação ICMS">
              <Select
                className="ant-select--custom"
                defaultValue={props.selectedIcms}
                value={props.selectedIcms}
                onChange={(e) => props.handleChangeField(e, "DescricaoIcms")}
              >
                <Option value={null}>Todos</Option>
                {icmsOptions.map((item) => {
                  return (
                    <Option key={item.id} value={item.value}>
                      {item.text}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Nº Documento Fiscal">
              <Input
                className="form-control"
                name="NumeroNota"
                value={sNumeroNota && sNumeroNota.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
                maxLength="100"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Modelo">
              <Input
                className="form-control"
                name="Modelo"
                value={sModelo && sModelo.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
                maxLength="2"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }} 
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="CFOP">
              <Input
                className="form-control"
                name="Cfop"
                value={sCfop && sCfop.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
                maxLength="4"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}               
                />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="CST ICMS">
              <Input
                className="form-control"
                name="Cst"
                value={sCst && sCst.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
                maxLength="3"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}
                />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Chave">
              <Input
                className="form-control"
                name="Chave"
                value={sChave && sChave.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
                maxLength="44"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Indicador de Operaçao">
              <Input
                className="form-control"
                name="IndicadorOperacao"
                value={sIndicadorOperacao && sIndicadorOperacao.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                type="number"
                min="0" 
                maxLength="2"
                onInput={(e) =>{
                  if(e.target.value.length > e.target.maxLength)
                  e.target.value = e.target.value.slice(0,e.target.maxLength);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Situaçao do Documento">
              <Input
                className="form-control"
                name="Situacao"
                value={sSituacao && sSituacao.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                maxLength="100"
                type="text"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Quantidade">
              <InputMask
                className="form-control"
                name="Quantidade"
                value={sQuantidade && sQuantidade.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                min="0"
                type="number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Valor">
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                prefix={"R$ "}
                className="form-control"
                name="TotalBruto"
                value={sTotalBruto == null ? "" : sTotalBruto.substr(1)}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
                maxLength="101"
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Dia">
              <Input
                name="DataEmissao"
                type="number"
                min={1}
                max={31}
                value={sDataEmissao && sDataEmissao.substr(8)}
                addonAfter={`${props.period.month}/${props.period.year}`}
                onChange={props.handleChangeField}
                onPressEnter={props.handleFilters}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div className="ant-drawer__footer">
        <Button className="mr-3" onClick={() => cleanFilters()}>
          Limpar
        </Button>

        <Button
          onClick={() => {
            props.handleFilters();
            props.onClose();
          }}
          type="primary"
        >
          Filtrar
        </Button>
      </div>
    </Drawer>
  );
};

export default DrawerFilter;
